export default __webpack_public_path__ + "static/media/Bomba-dark.98dfe80c.png";